export const SIGNIN = 'SIGNIN';
export const SIGNIN_SUCCESS = 'SIGNIN_SUCCESS';
export const SIGNIN_FAILURE = 'SIGNIN_FAILURE';

export const VERIFY_2FA = 'VERIFY_2FA';
export const VERIFY_2FA_SUCCESS = 'VERIFY_2FA_SUCCESS';
export const VERIFY_2FA_FAILURE = 'VERIFY_2FA_FAILURE';

export const LOGOUT = 'LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

export const USER_PROFILE = 'USER_PROFILE';
export const USER_PROFILE_SUCCESS = 'USER_PROFILE_SUCCESS';
export const USER_PROFILE_FAILURE = 'USER_PROFILE_FAILURE';

export const USER_PROFILE_DATA = 'USER_PROFILE_DATA';
export const USER_PROFILE_DATA_SUCCESS = 'USER_PROFILE_DATA_SUCCESS';
export const USER_PROFILE_DATA_FAILURE = 'USER_PROFILE_DATA_FAILURE';

export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';

export const LAST_SEEN_TOGGLE = 'LAST_SEEN_TOGGLE';
export const LAST_SEEN_TOGGLE_SUCCESS = 'LAST_SEEN_TOGGLE_SUCCESS';
export const LAST_SEEN_TOGGLE_FAILURE = 'LAST_SEEN_TOGGLE_FAILURE';

export const CHAT_CHANNEL = 'CHAT_CHANNEL';
export const CHAT_CHANNEL_SUCCESS = 'CHAT_CHANNEL_SUCCESS';
export const CHAT_CHANNEL_FAILURE = 'CHAT_CHANNEL_FAILURE';

export const CREATE_CHAT_CHANNEL = 'CREATE_CHAT_CHANNEL';
export const CREATE_CHAT_CHANNEL_SUCCESS = 'CREATE_CHAT_CHANNEL_SUCCESS';
export const CREATE_CHAT_CHANNEL_FAILURE = 'CREATE_CHAT_CHANNEL_FAILURE';

export const MESSAGE_CHAT_CHANNEL = 'MESSAGE_CHAT_CHANNEL';
export const MESSAGE_CHAT_CHANNEL_SUCCESS = 'MESSAGE_CHAT_CHANNEL_SUCCESS';
export const MESSAGE_CHAT_CHANNEL_DIRECT_UPDATE = 'MESSAGE_CHAT_CHANNEL_DIRECT_UPDATE';
export const MESSAGE_CHAT_CHANNEL_FAILURE = 'MESSAGE_CHAT_CHANNEL_FAILURE';

export const DELETE_MESSAGE = 'DELETE_MESSAGE';
export const DELETE_MESSAGE_SUCCESS = 'DELETE_MESSAGE_SUCCESS';
export const DELETE_MESSAGE_FAILURE = 'DELETE_MESSAGE_FAILURE';

export const ADD_USERS_GROUP = 'ADD_USERS_GROUP';
export const ADD_USERS_GROUP_SUCCESS = 'ADD_USERS_GROUP_SUCCESS';
export const ADD_USERS_GROUP_FAILURE = 'ADD_USERS_GROUP_FAILURE';

export const UNREAD_MESSAGE_DOT = 'UNREAD_MESSAGE_DOT';
export const UNREAD_MESSAGE_DOT_SUCCESS = 'UNREAD_MESSAGE_DOT_SUCCESS';
export const UNREAD_MESSAGE_DOT_FAILURE = 'UNREAD_MESSAGE_DOT_FAILURE';

export const CREATE_GROUP = 'CREATE_GROUP';
export const CREATE_GROUP_SUCCESS = 'CREATE_GROUP_SUCCESS';
export const CREATE_GROUP_FAILURE = 'CREATE_GROUP_FAILURE';

export const CREATE_GROUP_ADD_ID = 'CREATE_GROUP_ADD_ID';
export const CREATE_GROUP_ADD_ID_SUCCESS = 'CREATE_GROUP_ADD_ID_SUCCESS';
export const CREATE_GROUP_ADD_ID_FAILURE = 'CREATE_GROUP_ADD_ID_FAILURE';

export const GLOBAL_SEARCH_CHATS_GROUPS = 'GLOBAL_SEARCH_CHATS_GROUPS';
export const GLOBAL_SEARCH_CHATS_GROUPS_SUCCESS = 'GLOBAL_SEARCH_CHATS_GROUPS_SUCCESS';
export const GLOBAL_SEARCH_CHATS_GROUPS_FAILURE = 'GLOBAL_SEARCH_CHATS_GROUPS_FAILURE';

export const SELECTED_CHAT_USER = 'SELECTED_CHAT_USER';
export const SELECTED_CHAT_USER_SUCCESS = 'SELECTED_CHAT_USER_SUCCESS';
export const SELECTED_CHAT_USER_FAILURE = 'SELECTED_CHAT_USER_FAILURE';

export const UPLOAD_CAHT_MEDIA = 'UPLOAD_CAHT_MEDIA';
export const UPLOAD_CAHT_MEDIA_SUCCESS = 'UPLOAD_CAHT_MEDIA_SUCCESS';
export const UPLOAD_CAHT_MEDIA_FAILURE = 'UPLOAD_CAHT_MEDIA_FAILURE';

export const REPORT_MSG = 'REPORT_MSG';
export const REPORT_MSG_SUCCESS = 'REPORT_MSG_SUCCESS';
export const REPORT_MSG_FAILURE = 'REPORT_MSG_FAILURE';

export const SHARE_MEDIA = 'SHARE_MEDIA';
export const SHARE_MEDIA_SUCCESS = 'SHARE_MEDIA_SUCCESS';
export const SHARE_MEDIA_FAILURE = 'SHARE_MEDIA_FAILURE';

export const SEND_MESSAGE = 'SEND_MESSAGE';
// Reconciles an optimistically-inserted message with the server's answer.
export const MESSAGE_SETTLED = 'MESSAGE_SETTLED';
export const CLEAR_CHAT_MESSAGES = 'CLEAR_CHAT_MESSAGES';
export const DELETED_MESSAGE_NOW = 'DELETED_MESSAGE_NOW';
export const DELETED_THREAD_MESSAGE_NOW = 'DELETED_THREAD_MESSAGE_NOW';

export const MISSED_CALL_COUNT = 'MISSED_CALL_COUNT';
// export const GET_POSTS_SUCCESS = "GET_POSTS_SUCCESS"
// export const GET_POSTS_FAILURE = "GET_POSTS_FAILURE"

export const LOADER_TRUE = 'LOADER_TRUE';
export const LOADER_FALSE = 'LOADER_FALSE';

//Calling
export const START_CALL = 'START_CALL';
export const START_CALL_SUCCESS = 'START_CALL_SUCCESS';
export const START_CALL_FAILURE = 'START_CALL_FAILURE';

export const JOIN_CALL = 'JOIN_CALL';
export const JOIN_CALL_SUCCESS = 'JOIN_CALL_SUCCESS';
export const JOIN_CALL_FAILURE = 'JOIN_CALL_FAILURE';

export const RECENT_CALL_HISTORY = 'RECENT_CALL_HISTORY';
export const RECENT_CALL_HISTORY_SUCCESS = 'RECENT_CALL_HISTORY_SUCCESS';
export const RECENT_CALL_HISTORY_FAILURE = 'RECENT_CALL_HISTORY_FAILURE';

export const MISSED_CALL_HISTORY = 'MISSED_CALL_HISTORY';
export const MISSED_CALL_HISTORY_SUCCESS = 'MISSED_CALL_HISTORY_SUCCESS';
export const MISSED_CALL_HISTORY_FAILURE = 'MISSED_CALL_HISTORY_FAILURE';

export const USERS_DATA = 'USERS_DATA';
export const USERS_DATA_SUCCESS = 'USERS_DATA_SUCCESS';
export const USERS_DATA_FAILURE = 'USERS_DATA_FAILURE';

export const GROUP_MEMBERS = 'GROUP_MEMBERS';
export const GROUP_MEMBERS_SUCCESS = 'GROUP_MEMBERS_SUCCESS';
export const GROUP_MEMBERS_FAILURE = 'GROUP_MEMBERS_FAILURE';

export const UPDATE_CREATE_GROUP = 'UPDATE_CREATE_GROUP';
export const UPDATE_CREATE_GROUP_SUCCESS = 'UPDATE_CREATE_GROUP_SUCCESS';
export const UPDATE_CREATE_GROUP_FAILURE = 'UPDATE_CREATE_GROUP_FAILURE';

export const MULTIPLE_CALL_USERS_DATA = 'MULTIPLE_CALL_USERS_DATA';
export const MULTIPLE_CALL_USERS_DATA_SUCCESS = 'MULTIPLE_CALL_USERS_DATA_SUCCESS';
export const MULTIPLE_CALL_USERS_DATA_FAILURE = 'MULTIPLE_CALL_USERS_DATA_FAILURE';

/**
 * One call's own record. Answers "is this call still going?" for the rejoin path,
 * so it is callback-only — nothing keeps it in the store.
 */
export const CALL_DETAILS = 'CALL_DETAILS';
export const CALL_SESSION = 'CALL_SESSION';
export const ACTIVE_GROUP_CALL = 'ACTIVE_GROUP_CALL';

export const MULTIPLE_CALLER = 'MULTIPLE_CALLER';
export const EMPTY_CALL_HISTORY = 'EMPTY_CALL_HISTORY';

// Threads
export const CREATE_THREADS = 'CREATE_THREADS';
export const CREATE_THREADS_SUCCESS = 'CREATE_THREADS_SUCCESS';
export const CREATE_THREADS_FAILURE = 'CREATE_THREADS_FAILURE';

export const JOIN_THREADS = 'JOIN_THREADS';
export const JOIN_THREADS_SUCCESS = 'JOIN_THREADS_SUCCESS';
export const JOIN_THREADS_FAILURE = 'JOIN_THREADS_FAILURE';

export const THREAD_DETAILS = 'THREAD_DETAILS';
export const THREAD_DETAILS_SUCCESS = 'THREAD_DETAILS_SUCCESS';
export const THREAD_DETAILS_FAILURE = 'THREAD_DETAILS_FAILURE';

export const THREAD_LISTING = 'THREAD_LISTING';
export const THREAD_LISTING_SUCCESS = 'THREAD_LISTING_SUCCESS';
export const THREAD_LISTING_FAILURE = 'THREAD_LISTING_FAILURE';

export const UPLOAD_THREAD_MEDIA = 'UPLOAD_THREAD_MEDIA';
export const UPLOAD_THREAD_MEDIA_SUCCESS = 'UPLOAD_THREAD_MEDIA_SUCCESS';
export const UPLOAD_THREAD_MEDIA_FAILURE = 'UPLOAD_THREAD_MEDIA_FAILURE';

export const SEND_THREAD = 'SEND_THREAD';
export const CLEAR_CHAT_THREAD = 'CLEAR_CHAT_THREAD';
export const LOADING_SET = 'LOADING_SET';

export const THREAD_CHAT_CHANNEL = 'THREAD_CHAT_CHANNEL';
export const THREAD_CHAT_CHANNEL_SUCCESS = 'THREAD_CHAT_CHANNEL_SUCCESS';
export const THREAD_CHAT_CHANNEL_FAILURE = 'THREAD_CHAT_CHANNEL_FAILURE';
export const THREADS_CHAT_CHANNEL_DIRECT_UPDATE = 'THREADS_CHAT_CHANNEL_DIRECT_UPDATE';

//Notifications
export const TOGGLE_NOTIFICATIONS = 'TOGGLE_NOTIFICATIONS';
export const TOGGLE_NOTIFICATIONS_SUCCESS = 'TOGGLE_NOTIFICATIONS_SUCCESS';
export const TOGGLE_NOTIFICATIONS_FAILURE = 'TOGGLE_NOTIFICATIONS_FAILURE';

export const NOTIFICATIONS_LISTS = 'NOTIFICATIONS_LISTS';
export const NOTIFICATIONS_LISTS_SUCCESS = 'NOTIFICATIONS_LISTS_SUCCESS';
export const NOTIFICATIONS_LISTS_FAILURE = 'NOTIFICATIONS_LISTS_FAILURE';

export const NOTIFICATIONS_UNREAD_COUNT = 'NOTIFICATIONS_UNREAD_COUNT';
export const NOTIFICATIONS_UNREAD_COUNT_SUCCESS = 'NOTIFICATIONS_UNREAD_COUNT_SUCCESS';
export const NOTIFICATIONS_UNREAD_COUNT_FAILURE = 'NOTIFICATIONS_UNREAD_COUNT_FAILURE';

export const MARK_NOTIFICATIONS_READ = 'MARK_NOTIFICATIONS_READ';
export const MARK_NOTIFICATIONS_READ_SUCCESS = 'MARK_NOTIFICATIONS_READ_SUCCESS';
export const MARK_NOTIFICATIONS_READ_FAILURE = 'MARK_NOTIFICATIONS_READ_FAILURE';

export const GET_USER_PROFILE = 'GET_USER_PROFILE';
export const GET_USER_PROFILE_SUCCESS = 'GET_USER_PROFILE_SUCCESS';
export const GET_USER_PROFILE_FAILURE = 'GET_USER_PROFILE_FAILURE';

export const EDIT_USER_PROFILE = 'EDIT_USER_PROFILE';
export const EDIT_USER_PROFILE_SUCCESS = 'EDIT_USER_PROFILE_SUCCESS';
export const EDIT_USER_PROFILE_FAILURE = 'EDIT_USER_PROFILE_FAILURE';

export const DELETE_USER_PROFILE = 'DELETE_USER_PROFILE';
export const DELETE_USER_PROFILE_SUCCESS = 'DELETE_USER_PROFILE_SUCCESS';
export const DELETE_USER_PROFILE_FAILURE = 'DELETE_USER_PROFILE_FAILURE';

export const DELETE_THREAD = 'DELETE_THREAD';
export const DELETE_THREAD_SUCCESS = 'DELETE_THREAD_SUCCESS';
export const DELETE_THREAD_FAILURE = 'DELETE_THREAD_FAILURE';

export const DELETE_CHANNEL = 'DELETE_CHANNEL';
export const DELETE_CHANNEL_SUCCESS = 'DELETE_CHANNEL_SUCCESS';
export const DELETE_CHANNEL_FAILURE = 'DELETE_CHANNEL_FAILURE';

export const JOIN_GROUP = 'JOIN_GROUP';
export const JOIN_GROUP_SUCCESS = 'JOIN_GROUP_SUCCESS';
export const JOIN_GROUP_FAILURE = 'JOIN_GROUP_FAILURE';

export const LEAVE_GROUP = 'LEAVE_GROUP';
export const LEAVE_GROUP_SUCCESS = 'LEAVE_GROUP_SUCCESS';
export const LEAVE_GROUP_FAILURE = 'LEAVE_GROUP_FAILURE';

// Channels (broadcast groups) — admin management
export const PROMOTE_CHANNEL_ADMINS = 'PROMOTE_CHANNEL_ADMINS';
export const PROMOTE_CHANNEL_ADMINS_SUCCESS = 'PROMOTE_CHANNEL_ADMINS_SUCCESS';
export const PROMOTE_CHANNEL_ADMINS_FAILURE = 'PROMOTE_CHANNEL_ADMINS_FAILURE';

export const DEMOTE_CHANNEL_ADMIN = 'DEMOTE_CHANNEL_ADMIN';
export const DEMOTE_CHANNEL_ADMIN_SUCCESS = 'DEMOTE_CHANNEL_ADMIN_SUCCESS';
export const DEMOTE_CHANNEL_ADMIN_FAILURE = 'DEMOTE_CHANNEL_ADMIN_FAILURE';

export const TRANSFER_CHANNEL_OWNERSHIP = 'TRANSFER_CHANNEL_OWNERSHIP';
export const TRANSFER_CHANNEL_OWNERSHIP_SUCCESS = 'TRANSFER_CHANNEL_OWNERSHIP_SUCCESS';
export const TRANSFER_CHANNEL_OWNERSHIP_FAILURE = 'TRANSFER_CHANNEL_OWNERSHIP_FAILURE';

export const REMOVE_CHANNEL_MEMBER = 'REMOVE_CHANNEL_MEMBER';
export const REMOVE_CHANNEL_MEMBER_SUCCESS = 'REMOVE_CHANNEL_MEMBER_SUCCESS';
export const REMOVE_CHANNEL_MEMBER_FAILURE = 'REMOVE_CHANNEL_MEMBER_FAILURE';

// Retract a message for every member of a channel (admin-only, server-enforced).
export const RETRACT_MESSAGE = 'RETRACT_MESSAGE';
export const RETRACT_MESSAGE_SUCCESS = 'RETRACT_MESSAGE_SUCCESS';
export const RETRACT_MESSAGE_FAILURE = 'RETRACT_MESSAGE_FAILURE';

// Applied when the server reports a message was deleted for everyone. Keyed on
// message_id, not a list index: the stream shifts as history loads, so an
// index-based patch can land on the wrong bubble.
export const MESSAGE_DELETED_FOR_ALL = 'MESSAGE_DELETED_FOR_ALL';

// Saved messages (bookmarks / starring).
export const TOGGLE_SAVE_MESSAGE = 'TOGGLE_SAVE_MESSAGE';
export const TOGGLE_SAVE_MESSAGE_SUCCESS = 'TOGGLE_SAVE_MESSAGE_SUCCESS';
export const TOGGLE_SAVE_MESSAGE_FAILURE = 'TOGGLE_SAVE_MESSAGE_FAILURE';

export const SAVED_MESSAGES_LIST = 'SAVED_MESSAGES_LIST';
export const SAVED_MESSAGES_LIST_SUCCESS = 'SAVED_MESSAGES_LIST_SUCCESS';
export const SAVED_MESSAGES_LIST_FAILURE = 'SAVED_MESSAGES_LIST_FAILURE';

// Optimistic local patch for the star, keyed on message_id for the same reason
// MESSAGE_DELETED_FOR_ALL is: the star is tapped mid-scroll, and by the time the
// request resolves the bubble's index has moved. Dispatched before the request and
// reverted by TOGGLE_SAVE_MESSAGE_FAILURE, so the star never lies about server state.
export const MESSAGE_SAVE_STATE = 'MESSAGE_SAVE_STATE';

//CONTACTS
export const CREATE_CONTACT = 'CREATE_CONTACT';
export const CREATE_CONTACT_SUCCESS = 'CREATE_CONTACT_SUCCESS';
export const CREATE_CONTACT_FAILURE = 'CREATE_CONTACT_FAILURE';

export const DELETE_CONTACT = 'DELETE_CONTACT';
export const DELETE_CONTACT_SUCCESS = 'DELETE_CONTACT_SUCCESS';
export const DELETE_CONTACT_FAILURE = 'DELETE_CONTACT_FAILURE';

export const UPDATE_CONTACT = 'UPDATE_CONTACT';
export const UPDATE_CONTACT_SUCCESS = 'UPDATE_CONTACT_SUCCESS';
export const UPDATE_CONTACT_FAILURE = 'UPDATE_CONTACT_FAILURE';

export const LIST_CONTACTS = 'LIST_CONTACTS';
export const LIST_CONTACTS_SUCCESS = 'LIST_CONTACTS_SUCCESS';
export const LIST_CONTACTS_FAILURE = 'LIST_CONTACTS_FAILURE';

// App Lock / Passcode
export const PASSCODE_TOGGLE = 'PASSCODE_TOGGLE';
export const PASSCODE_TOGGLE_SUCCESS = 'PASSCODE_TOGGLE_SUCCESS';
export const PASSCODE_TOGGLE_FAILURE = 'PASSCODE_TOGGLE_FAILURE';

export const VERIFY_PASSCODE = 'VERIFY_PASSCODE';
export const VERIFY_PASSCODE_SUCCESS = 'VERIFY_PASSCODE_SUCCESS';
export const VERIFY_PASSCODE_FAILURE = 'VERIFY_PASSCODE_FAILURE';

export const UPDATE_PASSCODE = 'UPDATE_PASSCODE';
export const UPDATE_PASSCODE_SUCCESS = 'UPDATE_PASSCODE_SUCCESS';
export const UPDATE_PASSCODE_FAILURE = 'UPDATE_PASSCODE_FAILURE';

export const APP_LOCK_TRIGGER = 'APP_LOCK_TRIGGER';
export const APP_UNLOCK = 'APP_UNLOCK';

export const APP_LOCK_TIMER_START = 'APP_LOCK_TIMER_START';
export const APP_LOCK_TIMER_STOP = 'APP_LOCK_TIMER_STOP';

// Contact Support
export const CONTACT_SUPPORT = 'CONTACT_SUPPORT';
export const CONTACT_SUPPORT_SUCCESS = 'CONTACT_SUPPORT_SUCCESS';
export const CONTACT_SUPPORT_FAILURE = 'CONTACT_SUPPORT_FAILURE';

// Paged channel roster — GET /chat/group/:id/members. Separate from GROUP_MEMBERS,
// which fetches the channel plus one bounded roster in a single payload and is what
// the header/permissions read; this is the scrollable list under it.
export const CHANNEL_MEMBERS_PAGE = 'CHANNEL_MEMBERS_PAGE';
export const CHANNEL_MEMBERS_PAGE_SUCCESS = 'CHANNEL_MEMBERS_PAGE_SUCCESS';
export const CHANNEL_MEMBERS_PAGE_FAILURE = 'CHANNEL_MEMBERS_PAGE_FAILURE';

// A conversation was touched by an inbound socket event. Patches the one row in the
// loaded list instead of re-reading the whole list — which is what the socket handler
// used to do, on every single inbound message.
export const CONVERSATION_TOUCHED = 'CONVERSATION_TOUCHED';

// ── Presence ────────────────────────────────────────────────────────────────────
// One shared map of who is online, replacing the per-component copies the sidebar and
// the conversation pane each kept. Two components holding their own `useState` from the
// same socket event meant the same person could render green in one and grey in the
// other in the same frame — and the pane's copy started `false` and was only ever
// updated by a broadcast, so an online peer read as offline until an unrelated user
// happened to connect.
export const PRESENCE_MERGE = 'PRESENCE_MERGE';
export const PRESENCE_CHANGED = 'PRESENCE_CHANGED';
export const PRESENCE_RESET = 'PRESENCE_RESET';

// A channel was marked read by this client. Patches the one row's badge in the loaded
// conversation list instead of re-reading the list: the read handler used to dispatch
// GLOBAL_SEARCH_CHATS_GROUPS with no arguments, which returns unfiltered page one — so
// opening a conversation (and every inbound message while it stayed open) cleared the
// sidebar's active search and discarded every page the reader had scrolled through.
export const CHANNEL_READ = 'CHANNEL_READ';

// Somebody else read a channel this client is in. Distinct from CHANNEL_READ, which is
// this client's own read: a peer opening the conversation moves the read-by-everyone
// timestamp but must NOT clear this reader's unread badge.
export const CHANNEL_READ_RECEIPT = 'CHANNEL_READ_RECEIPT';
